<template>
<div class="chapter">
<div class="inner_page">
<div id="fm6">
<p class="dedication"><em class="italic">This novel is dedicated to the memory of Sophia Wiseman and Maryanne Wiseman, and their mother, ‘Rugig’.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1097b9ab